class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.sessionStorageKey = "announcementBarClosed";
    this.closeButton = this.querySelector("[data-close-button]");
    if (this.closeButton) {
      this.closeButton.addEventListener("click", this.onClose.bind(this));
    }
    this.timerInterval = null; // Prevent duplicate intervals
  }

  connectedCallback() {
    if (sessionStorage.getItem(this.sessionStorageKey)) return;
    this.classList.remove("hidden");
    this.initSlider();
    this.initCountdownTimer(); // Initialize the countdown timer
  }

  initSlider() {
    const swiperElement = this.querySelector(".swiper");
    if (!swiperElement) return;

    this.slider = new Swiper(swiperElement, {
      slidesPerView: 1,
      rewind: true,
      draggable: true,
      autoplay: { delay: 5000 },
      navigation: {
        prevEl: "[data-arrow-prev]",
        nextEl: "[data-arrow-next]",
      },
    });
  }

  initCountdownTimer() {
    const timerElement = document.querySelector("#countdown-timer");
    if (!timerElement) return;

    const countdownValue = timerElement.querySelector(".countdown-value");
    if (!countdownValue) return;

const updateTimer = () => {
  const now = new Date();
  const hours = now.getHours();
  const day = now.getDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6

  let displayText = "";
  let countdownText = "";

  // Set noonToday as the next upcoming 12:00
  const noonToday = new Date(now);
  noonToday.setHours(12, 0, 0, 0);

  // If the current time is **past noon**, move to **tomorrow's** noon
  if (now.getHours() >= 12) {
    noonToday.setDate(noonToday.getDate() + 1);
  }

  // Calculate time remaining until noon
  let timeRemaining = noonToday.getTime() - now.getTime();

  // Ensure no negative countdowns by adjusting logic
  if (timeRemaining < 0) {
    timeRemaining = 0;
  }

  // Convert remaining time to hours, minutes, seconds
  const hoursLeft = Math.floor(timeRemaining / (1000 * 60 * 60));
  const minutesLeft = Math.floor(
    (timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
  );
  const secondsLeft = Math.floor((timeRemaining % (1000 * 60)) / 1000);

  // Format countdown display
  countdownText = `${hoursLeft}T ${minutesLeft}M ${secondsLeft}S`;

  // Predefined texts
  const orderTodayText = `Bestil inden ${countdownText} for afsendelse i dag.`;
  const orderTomorrowText =
    "Bestil nu og vi sender din ordre inden kl. 12 i morgen.";
  const orderMondayText =
    "Bestil nu og din ordre sendes mandag inden kl. 12.";

  // **New logic for Friday after 12:00 PM**
  if (day === 5 && hours >= 12) {
    displayText = orderMondayText;
  } 
  // **Saturday & Sunday should always show Monday message**
  else if (day === 6 || day === 0) {
    displayText = orderMondayText;
  }
  // **Weekdays logic (Monday-Friday before 12:00 PM)**
  else if (day >= 1 && day <= 5) {
    displayText = hours < 12 ? orderTodayText : orderTomorrowText;
  }

  // Ensure countdown text is styled properly
  countdownValue.innerHTML = displayText.replace(
    countdownText,
    `<span class="countdown-highlight">${hoursLeft}T ${minutesLeft}M ${secondsLeft}S</span>`
  );
};

// Ensure only one interval runs
if (!this.timerInterval) {
  this.timerInterval = setInterval(updateTimer, 1000);
  updateTimer(); // Run immediately
}


    // Ensure only one interval runs
    if (!this.timerInterval) {
      this.timerInterval = setInterval(updateTimer, 1000);
      updateTimer(); // Run immediately
    }
  }

  onClose() {
    this.classList.add("hidden");
    sessionStorage.setItem(this.sessionStorageKey, true);
  }
}

customElements.define("announcement-bar", AnnouncementBar);
